import React from 'react'

import classNames from 'classnames'

import yarnpng from '../static/yarn.png'
import npmpng from '../static/npm.png'

export default class extends React.Component {
  state = {
    f: true,
    showManager: 1
  }

  handleChange = (l) => {
    this.setState({
      f: false,
      showManager: l
    })
  }

  render () {
    const { showManager, f } = this.state

    let npmClass = classNames({
      npm: true,
      vs: showManager === 0 && !f
    })

    let yarnClass = classNames({
      yarn: true,
      vs: showManager === 1 && !f
    })

    let yrn = classNames({
      yrn: true,
      vt: showManager === 1 && !f
    })

    let npmn = classNames({
      npmn: true,
      vt: showManager === 0 && !f
    })

    return (
      <div className="container">
        <div className="column">
          <h2 className="to fs54">Wooo</h2>
          <h3 className="text fs28">Tool that adds Redux to your React project without pain</h3>
          <div className="pick-pm">
            <h3 className="text">Pick your prefered package manager</h3>
            <div onClick={() => this.handleChange(1)} className={yarnClass}>
              <img className="imgy" src={yarnpng} alt="" />
            </div>
            <div onClick={() => this.handleChange(0)} className={npmClass}>
              <img className="imgy" src={npmpng} alt="" />
            </div>
          </div>
          <div className="tt">
            <div className={yrn}>
              <ul>
                <li>1. Install wooo globally with bash</li>
                  <ul>
                    <li>$ yarn global add redux-wooo</li>
                  </ul>
                <li>2. Use wooo command with specified directory</li>
                  <ul>
                    <li>$ wooo -d ./install_here</li>
                  </ul>
              </ul>
            </div>
            <div className={npmn}>
              <ul>
                <li>1. Install wooo globally with bash</li>
                  <ul>
                    <li>$ npm install -g redux-wooo</li>
                  </ul>
                <li>2. Use wooo command with specified directory and npm flag</li>
                  <ul>
                    <li>$ wooo -d ./install_here -n</li>
                  </ul>
              </ul>
            </div>
          </div>
        </div>
        <div className="column fs">
          <h3>What it does?</h3>

          <p>Install required dependencies and Create files in specified path with:</p>

          <ul>
            <li>1. One duck module</li>
            <li>2. One stateless component with CSS</li>
            <li>3. React-router and react-router-redux reducer</li>
            <li>4. Redux store configuration for production and development</li>
            <li>5. App Container</li>
          </ul>

          <h4>Be aware that this is just fast scaffolding, not actual code!</h4>
          <h4>
            Also, wooo comes with create-react-app in mind.
            It's as easy as just running command wooo -d ./src in CRA directory.
          </h4>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js